/* import __COLOCATED_TEMPLATE__ from './document-event-handlers.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { cancel, debounce } from '@ember/runloop';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { EMBERCOM_PROSEMIRROR_COMPOSER_ALLOW_MOUSEDOWN_CLASS } from '@intercom/embercom-prosemirror-composer/components/editor-api/constants';
let EditorApiDocumentEventHandlers = (_class = class EditorApiDocumentEventHandlers extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "document", _descriptor, this);
    _initializerDefineProperty(this, "window", _descriptor2, this);
    _defineProperty(this, "debouncedHoverStateTime", void 0);
  }
  setupHandlers(element) {
    this.document = element.ownerDocument;
    this.window = window;
  }
  updateHoverState(e) {
    this.composer?.updateHoverInfo(e);
  }
  willDestroy() {
    super.willDestroy();
    if (this.debouncedHoverStateTime) {
      cancel(this.debouncedHoverStateTime);
    }
  }
  get composer() {
    return this.args.composer;
  }
  get composerElement() {
    return this.args.composerElement;
  }
  onMouseUp() {
    if (this.composer?.state) {
      this.composer.state.mouseIsDown = false;
    }
  }
  onMouseDown(e) {
    let element = e.target;
    let formattingSidebarClass = String(this.composer.config.customStylesConfig?.formattingSidebarClass);
    do {
      if (element === this.composerElement || element.classList.contains('embercom-prosemirror-composer-pointer') || formattingSidebarClass && element.classList.contains(formattingSidebarClass) || element.classList.contains(EMBERCOM_PROSEMIRROR_COMPOSER_ALLOW_MOUSEDOWN_CLASS)) {
        return;
      }
    } while (element = element.parentElement);
    this.composer?.commands.collapseSelection();
  }
  onMouseOver(e) {
    this.debouncedHoverStateTime = debounce(this, this.updateHoverState, e, 250);
  }
  preventDefault(e) {
    e.preventDefault();
  }
  resize() {
    if (this.composer) {
      this.composer.scrollOrResizeHandler();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "document", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "window", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setupHandlers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupHandlers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMouseUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMouseUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMouseDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMouseDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMouseOver", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMouseOver"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preventDefault", [action], Object.getOwnPropertyDescriptor(_class.prototype, "preventDefault"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resize"), _class.prototype), _class);
export { EditorApiDocumentEventHandlers as default };